import './TilesComponent.scss';

import { ReactNode } from 'react';

import { useMediaQuery } from '@/hooks';
import EmblaCarousel from '@/pages/Landing/components/Carousel/EmblaCarousel';

const className = 'c-Tiles';

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  tiles: Array<{
    title: ReactNode;
    subtitle?: ReactNode;
    image: ReactNode;
  }>;
  useCarousel?: boolean;
}

export const TilesComponent = ({
  title,
  subtitle,
  tiles,
  useCarousel,
}: Props) => {
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)');

  const options = {
    slidesToScroll: isTablet ? 2 : 1,
    loop: true,
  };

  return (
    <div className={className}>
      <div className={`${className}__header`}>
        <div className={`${className}__header-title`}>{title}</div>
        <div className={`${className}__header-subtitle`}>{subtitle}</div>
      </div>

      {useCarousel ? (
        <>
          <div
            className={`${className}__tiles ${className}__tiles--tablet-down`}
          >
            <EmblaCarousel options={options}>
              {tiles.map(({ title, subtitle, image }, index) => (
                <div className={`${className}__tile`} key={index}>
                  <div className={`${className}__tile-image`}>{image}</div>
                  <div className={`${className}__tile-title`}>{title}</div>
                  <div className={`${className}__tile-subtitle`}>
                    {subtitle}
                  </div>
                </div>
              ))}
            </EmblaCarousel>
          </div>
          <div className={`${className}__tiles ${className}__tiles--desktop`}>
            {tiles.map(({ title, subtitle, image }, index) => (
              <div className={`${className}__tile`} key={index}>
                <div className={`${className}__tile-image`}>{image}</div>
                <div className={`${className}__tile-title`}>{title}</div>
                <div className={`${className}__tile-subtitle`}>{subtitle}</div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className={`${className}__tiles`}>
          {tiles.map(({ title, subtitle, image }, index) => (
            <div className={`${className}__tile`} key={index}>
              <div className={`${className}__tile-image`}>{image}</div>
              <div className={`${className}__tile-title`}>{title}</div>
              <div className={`${className}__tile-subtitle`}>{subtitle}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
